import $ from 'jquery';

export default function DFClipboard(textAreaSelector) {
  const $textarea = $(textAreaSelector);
  // if textAreaSelector not found, throw Error for easier debug
  if (!$textarea.length) {
    throw new Error(`Initiating DFClipboard with invalid selectr ${textAreaSelector}`);
  }
  const $activeTextArea = $textarea.filter(':visible');
  const $textAreaNode = $activeTextArea[0];

  function isSafari() {
    return navigator.userAgent.match(/safari/gim);
  }

  function selectText() {
    let range;
    let selection;

    $activeTextArea.focus();
    $activeTextArea.select();
    if (isSafari()) {
      range = document.createRange();
      range.selectNodeContents($textAreaNode);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      $textAreaNode.setSelectionRange(0, 999999);
    }
  }

  function copyToClipboard() {
    document.execCommand('copy');
  }

  const copy = function () {
    selectText();
    copyToClipboard();
  };

  return {
    copy,
  };
}
